import { ComponentWithAs, createIcon, IconProps } from '@chakra-ui/react'

export const SendIcon: ComponentWithAs<'svg', IconProps> = createIcon({
    displayName: 'SendIcon',
    viewBox: '0 0 24 24',
    path: <path d="M22 12L2 3V11.1L16.5455 12L2 12.9V21L22 12Z" fill="currentColor" />
})
